import WGAssessment from './wrapper';

export default WGAssessment;
